module.exports = __webpack_public_path__ + "img/icon-plane.0d41a980.svg";